import React from 'react';
import ProgressBar from 'react-bootstrap/ProgressBar';

import styles from './ProjectProgressBar.module.css';

const ProjectProgressBar: React.FC<{
  percentage: number;
  timeEstimate: string;
  isComplete: boolean;
}> = ({ percentage, timeEstimate, isComplete }) => (
  <div>
    <div className={styles.progressText}>
      <div className={styles.progressPercentage}>{percentage}%</div>
      {timeEstimate !== undefined && !isComplete ? (
        <div className={styles.timeEstimate}>{timeEstimate} to go</div>
      ) : null}
    </div>
    <div className={styles.progressBar}>
      <ProgressBar now={percentage} />
    </div>
  </div>
);

export default ProjectProgressBar;
